var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"background--views"},[_c('v-container',[_c(_vm.component,{tag:"component",attrs:{"isEdit":_vm.isEdit,"item":_vm.item},on:{"changeComponent":_vm.changeComponent,"edit":_vm.edit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }